import home from './src/home.vue'
import OpinionHotWords from './src/OpinionManager/OpinionHotWords.vue' //舆情热词
import OpinionMedia from './src/OpinionManager/OpinionMedia.vue' //活跃媒体TOP5
import OpinionTopics from './src/OpinionManager/OpinionTopics.vue' //最新舆情
import OpinionRealTime from './src/OpinionManager/OpinionRealTime.vue' //实时舆情走势
import OpinionAnalysisManager from './src/OpinionManager/OpinionAnalysisManager.vue' //实时舆情走势
import OpinionList from './src/OpinionManager/OpinionList.vue' //最新舆情
import OpinionCollect from './src/OpinionManager/OpinionCollect.vue' //最新舆情
import OpinionMediaTop5 from './src/OpinionManager/OpinionMediaTop5.vue' //最新舆情

let views = {
    home,
    OpinionHotWords,
    OpinionMedia,
    OpinionTopics,
    OpinionRealTime,
    OpinionAnalysisManager,
    OpinionList,
    OpinionCollect,
    OpinionMediaTop5
};

export default views;